import { useQuery } from 'react-query'

import {
  SystemPreferenceKeys,
  systemPreferenceQueryConfig,
} from '@webapp/platform/iam'

export const useQueryDefaultPODisclaimer = () => {
  const { data, isLoading } = useQuery(
    systemPreferenceQueryConfig.getValue(
      SystemPreferenceKeys.DEFAULT_DISCLAIMER
    )
  )

  return {
    // A never-set preference is the valid "no default set" state (BHV-018)
    value: data?.value ?? null,
    isLoading,
  }
}
